import { useState, useEffect } from 'react';

/**
 * Hook para detectar si la aplicación se está ejecutando bajo react-snap
 * durante el prerenderizado estático
 */
export const useIsReactSnap = () => {
  const [isReactSnap, setIsReactSnap] = useState(true);

  useEffect(() => {
    // Verificar si estamos en el servidor o durante prerenderizado
    const isServerSide = typeof window === 'undefined';
    const isSnapUserAgent = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
    const isSnapURL = typeof window !== 'undefined' && window.location.href.includes('react-snap');
    
    setIsReactSnap(isServerSide || isSnapUserAgent || isSnapURL);
  }, []);

  return isReactSnap;
};

/**
 * Función utilitaria para verificar si estamos en react-snap (síncrona)
 */
export const checkIsReactSnap = () => {
  if (typeof window === 'undefined') return true;
  if (typeof navigator === 'undefined') return true;
  if (navigator.userAgent === 'ReactSnap') return true;
  if (window.location.href.includes('react-snap')) return true;
  return false;
};

export default useIsReactSnap;
